export class TransportCost {
  constructor(public duration: string) {}
}
